import React from 'react';
import { TrendingUp, BarChart3, Zap } from 'lucide-react';

const PortfolioMetrics = ({ metrics, riskCategory }) => {
  if (!metrics) return null;

  const cards = [
    {
      label: 'Expected Return',
      value: `${(metrics.expectedReturn * 100).toFixed(1)}%`,
      icon: TrendingUp,
      color: 'text-green-600',
      bg: 'bg-green-50',
    },
    {
      label: 'Sharpe Ratio',
      value: metrics.sharpeRatio?.toFixed(2) || 'N/A',
      icon: BarChart3,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      label: 'Risk Profile',
      value: riskCategory || 'N/A',
      icon: Zap,
      color: riskCategory === 'AGGRESSIVE' ? 'text-red-600' : riskCategory === 'CONSERVATIVE' ? 'text-green-600' : 'text-blue-600',
      bg: riskCategory === 'AGGRESSIVE' ? 'bg-red-50' : riskCategory === 'CONSERVATIVE' ? 'bg-green-50' : 'bg-blue-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {cards.map((card, idx) => {
        const Icon = card.icon;
        return (
          <div key={idx} className="card flex items-center gap-4">
            <div className={`p-3 rounded-lg ${card.bg}`}>
              <Icon className={`h-6 w-6 ${card.color}`} />
            </div>
            <div>
              <p className="text-sm text-gray-500">{card.label}</p>
              <p className={`text-xl font-bold ${card.color}`}>{card.value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PortfolioMetrics;
